import React from 'react';
import PropTypes from 'prop-types';
import { useSquad } from '../../hooks/squad';
import { useLeadersInTeam } from '../../hooks/leaders';
import SquadPlayer from '../Team/SquadPlayer';

function TopPlayers({ match }) {
  const [homeTeamLeaders, loadingH, errorH] = useLeadersInTeam(
    match?.homeTeamAbbrv
  );
  const [visitingTeamLeaders, loadingV, errorV] = useLeadersInTeam(
    match?.visitingTeamAbbrv
  );

  const getTopPlayers = () => {
    if (homeTeamLeaders && visitingTeamLeaders) {
      const homeTeam = homeTeamLeaders?.goals.splice(0, 3);
      const visitingTeam = visitingTeamLeaders?.goals.splice(0, 3);

      return homeTeam.concat(visitingTeam);
    }

    return [];
  };

  return (
    <section className="row">
      <div className="col-12 d-flex px-sm-4 align-items-center mb-4 mt-5">
        <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
          Spelare att hålla koll på
        </h2>
      </div>
      <div className="col-12">
        <div className="overflow-x-auto d-flex flex-nowrap flex-lg-wrap row">
          {getTopPlayers()?.map((p) => (
            <SquadPlayer player={{ ...p?.player, p }} />
          ))}
        </div>
      </div>
    </section>
  );
}

TopPlayers.propTypes = {
  match: PropTypes.shape({
    homeTeamId: PropTypes.number.isRequired,
    visitingTeamId: PropTypes.number.isRequired,
  }).isRequired,
};

export default TopPlayers;
